import React from 'react';
import { Modal } from 'react-bootstrap';
import AccountStandardSize from './AccountStandardSize';

function StandardSizeModal({ show, onHide, accountId, currentStandardSize, defaultStandardSize, autoStandardSize, onTickerUpdate, onStandardSizeUpdate }) {
  return (
    <Modal 
      show={show} 
      onHide={onHide} 
      centered
      backdrop={true}
      keyboard={true}
      size="md"
    >
      <Modal.Header closeButton>
        <Modal.Title>
          Standard Size
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <AccountStandardSize 
          accountId={accountId}
          currentStandardSize={currentStandardSize}
          defaultStandardSize={defaultStandardSize}
          autoStandardSize={autoStandardSize}
          onTickerUpdate={onTickerUpdate}
          onClose={onHide}
          onStandardSizeUpdate={onStandardSizeUpdate}
        />
      </Modal.Body>
    </Modal>
  );
}

export default StandardSizeModal; 